import type { ReactNode } from 'react';
import { useState } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { Card, Dropdown } from 'react-bootstrap';
import { breakpoints, capitalize } from '@/helpers/utils';
import { topNavbarBreakpoint } from '@/config';

type NavbarDropdownProps = {
  title: string;
  children: ReactNode;
};

const NavbarDropdown = ({ title, children }: NavbarDropdownProps) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  return (
    <Dropdown
      show={dropdownOpen}
      onToggle={() => setDropdownOpen(!dropdownOpen)}
      onMouseOver={() => {
        const windowWidth = window.innerWidth;
        if (windowWidth >= breakpoints[topNavbarBreakpoint]) {
          setDropdownOpen(true);
        }
      }}
      onMouseLeave={() => {
        const windowWidth = window.innerWidth;
        if (windowWidth >= breakpoints[topNavbarBreakpoint]) {
          setDropdownOpen(false);
        }
      }}
    >
      <Dropdown.Toggle as={Link} to="#!" className="nav-link fw-semi-bold">
        {capitalize(title)}
      </Dropdown.Toggle>
      <Dropdown.Menu className="dropdown-menu-card mt-0 dropdown-caret">
        <Card
          className={classNames('shadow-none dark__bg-1000', {
            'navbar-card-pages': title === 'ابزارها'
          })}
        >
          <Card.Body className="scrollbar max-h-dropdown p-0 py-2">
            {children}
          </Card.Body>
        </Card>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default NavbarDropdown;
